import "./src/styles/global.css"
import React from "react"
import CookieBanner from "./src/components/cookieBanner"

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieBanner />
  </>
)